import './index.scss'
function FooterContainer(){
    return (
        <div className='footer-container flex-row-center'>©2022-2025 DZ Labs - all Rights Reserved, Crafted by DZ Labs DAO | &nbsp;<span className='pointer' onClick={e=>window.open('https://twitter.com/16DAOCoin','_blank')}>Contact US</span></div>
    )
}
export default FooterContainer;